// src/firebase.ts
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: "AIzaSyCbLccbOmcfxArdt6FgKvpraIEaK2ItLUs",
    authDomain: "hisabat-e88ed.firebaseapp.com",
    projectId: "hisabat-e88ed",
    storageBucket: "hisabat-e88ed.firebasestorage.app",
    messagingSenderId: "121120260394",
    appId: "1:121120260394:web:733251840a27bc12e75e53",
    measurementId: "G-Y5GRGZ1LDY"
};

const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp;
